import APIService from '@/services/APIService.js';

export default {
  listar() {
    return APIService.apiCall().get('/aws/ips-acesso-banco-dados/listar');
  },
  buscar(id) {
    return APIService.apiCall().get(`/aws/ips-acesso-banco-dados/buscar/${id}`);
  },
  listarSecurityGroupsDisponiveis() {
    return APIService.apiCall().get('/aws/ips-acesso-banco-dados/listar-security-groups-disponiveis');
  },
  salvar(postData) {
    return APIService.apiCall().post('/aws/ips-acesso-banco-dados/salvar', JSON.stringify(postData));
  },
  excluir(id) {
    return APIService.apiCall().delete(`/aws/ips-acesso-banco-dados/excluir/${id}`);
  }
};
